export const getFilenameFromContentDisposition = (h?: string, fallback = "file") => {
  if (!h) return fallback;

  // filename*=charset''urlencoded-name  (RFC 5987)
  const star = /filename\*=(?:[^']*)''([^;]+)/i.exec(h);
  if (star && star[1]) {
    const encoded = star[1].trim();
    try {
      // handle '+' (sometimes used for spaces) and percent-encoded names
      return decodeURIComponent(encoded.replace(/\+/g, "%20"));
    } catch {
      return encoded.replace(/\+/g, " ");
    }
  }

  // filename="maybe%20encoded.pdf"  or filename="normal name.pdf"
  const quoted = /filename="([^"]+)"/i.exec(h);
  if (quoted && quoted[1]) {
    const candidate = quoted[1].trim();
    try {
      return decodeURIComponent(candidate.replace(/\+/g, "%20"));
    } catch {
      return candidate.replace(/\+/g, " ");
    }
  }

  // filename=unquoted.pdf
  const unquoted = /filename=([^;]+)/i.exec(h);
  if (unquoted && unquoted[1]) {
    const candidate = unquoted[1].trim().replace(/^"|"$/g, "");
    try {
      return decodeURIComponent(candidate.replace(/\+/g, "%20"));
    } catch {
      return candidate.replace(/\+/g, " ");
    }
  }

  return fallback;
};
